import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
  loadInventory,
  loadInventorySeed,
  getItemStockStatus,
  uploadImageToStorage,
  uploadVideoToStorage,
  getItemStockDownload,
  transferInventory,
  updateInventory,
  downloadInventoryTemplate,
  uploadFileToStorage,
  deleteFileFromStorage,
  getAllStockStatus,
  inventoryOrderReport,
  stockDetails,
  inventoryOrderStatus,
  quickTransferInventory
} from "@/services/inventory";

@Module({
  namespaced: true
})
export default class Inventory extends VuexModule {
  // state
  inventoryList = [];
  stockdata = [];

  // actions
  @Action
  public async inventoryOrderStatus(payload) {
    try {
      const data = await inventoryOrderStatus(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }


  @Action
  public async stockDetails(payload) {
    try {
      const data = await stockDetails(payload);
      this.context.commit("setStockDetails", data.data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async inventoryOrderReport(payload) {
    try {
      const data = await inventoryOrderReport(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async loadInventory(payload) {
    try {
      const data = await loadInventory(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async loadInventorySeed(payload) {
    try {
      const data = await loadInventorySeed(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async transferInventoryQuick(payload) {
    try {
      const data = await quickTransferInventory(payload);
      return {
        error: false,
        data
      };
    } catch (error: any) {
      return {
        error: true,
        message: error.response.data.message
      };
    }
  }

  @Action
  public async updateInventory(payload) {
    try {
      const data = await updateInventory(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async transferInventory(payload) {
    try {
      const data = await transferInventory(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async getItemStockStatus(payload) {
    try {
      const data = await getItemStockStatus(payload.id, payload.data);
      return data;
    } catch (error) {
      throw error;
    }
  }


  @Action
  public async getAllStockStatus(payload) {
    try {
      const data = await getAllStockStatus(payload.data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async getItemStockDownload(payload) {
    try {
      const data = await getItemStockDownload(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async downloadInventoryTemplate(payload) {
    try {
      const data = await downloadInventoryTemplate(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async uploadFileToStorage(payload) {
    try {
      const data = await uploadFileToStorage(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async deleteFileFromStorage(payload) {
    try {
      const data = await deleteFileFromStorage(payload);
      return data;
    }
    catch (error) {
      throw error;
    }
  }

  @Action
  public async uploadImageToStorage(payload) {
    try {
      const data = await uploadImageToStorage(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async uploadVideoToStorage(payload) {
    try {
      const data = await uploadVideoToStorage(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  // mutations
  @Mutation
  public setInventoryList(data: any) {
    this.inventoryList = data;
  }

  // getters
  get GetAllInventoryList() {
    return this.inventoryList;
  }

  @Mutation
  public setStockDetails(data: any) {
    this.stockdata = data;
  }

  //getters
  get GetStockDetails() {
    return this.stockdata;
  }

}
